// extracted by mini-css-extract-plugin
export default {"success-snackbar":"style_success-snackbar__46EuO","successSnackbar":"style_success-snackbar__46EuO"};